import { MetaFootnote } from '../types'

export const METADATA_DATA_FOOTNOTES: MetaFootnote[] = [
  {
    sup: '*',
    definition:
      'Merujuk pada SNI ISO tentang Metadata Spasial, maka format lintang:',
    children: [
      {
        text: 'Derajat lintang diekspresikan sebagai fraksi desimal derajat.',
      },
      {
        text: 'Seluruh derajat lintang harus direpresentasikan dengan angka desimal dua digit berkisar antara 0 sampai dengan 90.',
      },
      {
        text: 'Jika fraksi desimal derajat ditetapkan harus dipisah dari seluruh angka derajat dengan titik desimal.',
      },
      {
        text: 'Lintang utara ekuator harus dispesifikasikan dengan tanda plus (+), atau dengan tidak menyertakan tanda minus (-), mendahului dua digit derajat yang ditentukan.',
      },
      {
        text: 'Lintang selatan ekuator harus diberi tanda minus (-) mendahului dua digit derajat yang ditentukan.',
      },
    ],
  },
  {
    sup: '**',
    definition:
      'Merujuk pada SNI ISO tentang Metadata Spasial, maka format bujur:',
    children: [
      {
        text: 'Derajat bujur diekspresikan sebagai fraksi desimal deraj',
      },
      {
        text: 'Seluruh derajat bujur harus direpresentasikan dengan angka desimal tiga digit berkisar dari 0 sampai dengan 1',
      },
      {
        text: 'Jika fraksi desimal derajat ditetapkan harus dipisah dari seluruh angka derajat dengan titik desimal.',
      },
      {
        text: 'Bujur timur dari meridian utama harus dispesifikasikan dengan tanda plus (+) atau dengan tidak menyertakan tanda minus (-), mendahului tiga digit derajat buj',
      },
      {
        text: 'Bujur barat dari meridian utama harus diberi tanda minus (-) mendahului tiga digit derajat.',
      },
    ],
  },
]
